<template>
  <div class="body">
    <a id="back" @click="back()">戻る</a>
    <div v-if="!nomatch">
      <div id="sizeSetting">
        <br />サイズ設定
        <br />
        <span class="tag">
          <input
            id="yoko"
            type="range"
            min="400"
            max="1200"
            v-model="maxWidth"
            @input="widthChange"
          />
          <label>横幅サイズ</label>
        </span>
        <span class="tag">
          <input
            type="range"
            min="100"
            max="300"
            step="1"
            v-model="lineHeight"
            @input="HeighChange"
          />
          <label>行幅サイズ</label>
        </span>
        <span class="tag">
          <input
            type="range"
            min="10"
            max="30"
            step="0.5"
            v-model="fontSize"
            @input="fontSizeChange"
          />
          <label>文字サイズ</label>
        </span>
      </div>
      <hr />
      <div id="box" v-bind:style="{maxWidth: maxWidth+'px'}">
        <div class="pen">
          <small>ペンネーム:{{name}}</small>
        </div>
        <div class="title">
          <span>{{title}}</span>
        </div>
        <hr style="margin: 0em;margin-bottom:5px" />
        <p
          class="texts"
          v-if="isGet"
          v-bind:style="{lineHeight: lineHeight+'%',fontSize: fontSize+'px'}"
        >{{body}}</p>
        <div v-else>ちょっと待ってね</div>
        <hr style="margin: 0em;margin-bottom:5px" />
      </div>
      <div class="buttons" v-if="isGet">
        <span class="button" v-if="login">
          <br />いいねと思ったら⇒
          <button @click="goodButton">{{goodarray.indexOf(uid)==-1?"いいね":"いいね取り消し"}}</button>
          <br />
        </span>

        <span class="button" v-if="login&&touhyou">
          <br />この作品に投票する⇒
          <button @click="voteButton">{{!vote?'投票':'投票済み'}}</button>
          <br />
        </span>
        <br />
        <span class="nocut" v-if="touhyou">投票は1人にしかできません。</span>
        <span class="nocut" v-if="touhyou">
          前回投票された作品がある場合、
          <span class="nocut">新しい投票に上書きされます。</span>
        </span>

        <span class="button" v-if="!login">
          いいね、投票をするためには
          <a @click="loginButton()">ログイン</a>してください。
        </span>
        <br />
        <span class="nocut">評価システムについては</span>
        <span class="nocut">
          <router-link to="/Evaluate">こちら</router-link>をご確認ください。
        </span>
      </div>
      <br />
      <a id="back2" @click="back()">戻る</a>
    </div>
    <div v-if="nomatch">
      <h2>
        <span class="tag">urlが違う。もしくは削除された作品です。</span>
        <span class="tag">今一度お確かめください。</span>
      </h2>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Body",
  props: {},
  data: () => ({
    name: "",
    title: "",
    body: "",
    goodarray: [],
    vote: false,
    award: null,
    touhyou: false,

    maxWidth: 600,
    lineHeight: 180,
    fontSize: 16,

    login: false,
    isGet: false,
    uid: "",
    nomatch: false
  }),
  created() {
    // view が作られた時にデータを取得し、
    // そのデータは既に監視されています
    this.fetchData();
  },
  watch: {
    // ルートが変更されたらこのメソッドを再び呼び出します
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      if (this.$route.params.content) {
        this.name = this.$route.params.content.name || "";
        this.title = this.$route.params.content.title || "";
        this.body = this.$route.params.content.body || "";
        this.goodarray = this.$route.params.content.goodarray || [];
      }
      if (this.body === null || this.body === "") {
        firebase
          .database()
          .ref("/bodys/" + this.$route.params.id)
          .once("value")
          .then(snapshot => {
            var ssv = snapshot.val();
            if (ssv == null) {
              this.nomatch = true;
            } else {
              console.log("get body");
              this.title = ssv["title"];
              this.body = ssv["body"];
              this.isGet = true;
            }
          });
      } else {
        this.isGet = true;
      }
      if (this.name === null || this.name === "") {
        firebase
          .database()
          .ref("/intros/" + this.$route.params.id)
          .once("value")
          .then(snapshot => {
            var ssv = snapshot.val();
            if (ssv !== null) {
              this.name = ssv.name;
              this.goodarray = ssv.goodarray || [];
            }
          });
      }
      this.loginchack();
    },
    goodButton() {
      var i = this.goodarray.indexOf(this.uid);
      if (i == -1) {
        this.goodarray.push(this.uid);
      } else {
        this.goodarray.splice(i, 1);
      }
      const goodArray = firebase.functions().httpsCallable("goodArray");
      goodArray({ key: this.$route.params.id })
        .then(result => {
          console.log(result.data.goodarray);
          this.goodarray = result.data.goodarray;
        })
        .catch()
        .finally();
    },
    voteButton() {
      const voteFunc = firebase.functions().httpsCallable("vote");
      voteFunc({ key: this.$route.params.id })
        .then(result => {
          console.log(result.data.vote);
          this.vote = result.data.vote == this.$route.params.id;
        })
        .catch()
        .finally();
    },
    loginButton() {
      this.$router.replace({
        name: "Signin",
        params: {
          goodvote: true,
          id: this.$route.params.id,
          content: {
            name: this.name,
            title: this.title,
            body: this.body
          }
        }
      });
    },
    widthChange() {
      //this.bodyStyle.maxWidth = this.maxWidth + "px";
    },

    HeighChange() {},
    fontSizeChange() {},
    loginchack() {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.login = true;
          this.uid = user.uid;
          if (!this.vote) {
            firebase
              .database()
              .ref("/myLoom/" + this.uid)
              .once("value")
              .then(snapshot => {
                var ssv = snapshot.val();
                if (ssv !== null) {
                  console.log();
                  this.vote = ssv.vote && ssv.vote[this.$route.params.id];
                }
              });
          }
        } else {
          this.login = false;
          this.uid = "";
          this.vote = false;
        }
      });
    },
    back: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  cursor: pointer;
}
#sizeSetting {
  font-size: 14px;
}
.tag {
  display: inline-block;
  margin-right: 20px;
}
#box {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.pen {
  text-align: left;
  text-indent: 2%;
  margin-bottom: 5px;
}
.title {
  vertical-align: middle;
  text-align: left;
  padding-left: 4%;
  padding-right: 4%;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
.texts {
  text-align: left;
  margin-top: 0.1em;
  padding-left: 2%;
  padding-right: 2%;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
.buttons {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 900px;
  height: min-content;
}
.button {
  margin-bottom: 30px;
}
#good {
  margin: 10%;
}
#vote {
  margin: 10%;
}
.nocut {
  display: inline-block;
}
#back,
#back2 {
  margin-right: 80%;
  text-align: center;
}
</style>
